import { render } from "./ProfessionalInterpretation.vue?vue&type=template&id=235cb270"
import script from "./ProfessionalInterpretation.vue?vue&type=script&lang=js"
export * from "./ProfessionalInterpretation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__